"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _defaultTranslationsWithNamespaces = require("./defaultTranslationsWithNamespaces");
Object.keys(_defaultTranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _defaultTranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslationsWithNamespaces[key];
    }
  });
});
